//@flow
import styled from "styled-components"

const Section = styled.div`
  border-radius: 1rem;
  background: linear-gradient(
    180deg,
    ${props => props.theme.backgroundGradientDark},
    ${props => props.theme.backgroundGradientLight}
  );
  color: ${props => props.theme.secondaryText};
  display: flex;
  align-items: center;
  padding: 1rem;
  flex-grow: 1;
  margin: 1rem;
  flex-basis: 100rem;
  min-height: 10rem;

  &:first-child,
  &:last-child {
    margin-left: 0;
    margin-right: 0;
  }
`

export default Section



// WEBPACK FOOTER //
// ./src/Home/Section.js